export default {
  compareStateValU: null,
  compareStateValS: null,
  asyncThorwFunction (promise) {
    return promise
      .then(res => {
        return [null, res];
      })
      .catch(error => {
        return [error, null];
      });
  },
  compareStateFromHeartBeat: {
    u: function (state) {
      if (!this.compareStateValU || this.compareStateValU !== state) {
        this.compareStateValU = state;
        return false;
      } else {
        return true;
      }
    },
    s: function (state) {
      if (!this.compareStateValS || this.compareStateValS !== state) {
        this.compareStateValS = state;
        return false;
      } else {
        return true;
      }
    }
  },
  // 比较状态是否变更
  compareState (type, state) {
    return this.compareStateFromHeartBeat[type](state);
  },
  setToken: function (key) {
    const date = new Date().setHours(24, 0, 0, 0);
    localStorage.setItem(key, date);
  }
};
